import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ioValidators } from '@framework';
import { GuestModel, UserModel, UserProfileModel } from '@models';
import { AlertServices, UserServices } from '@services';
import { LayoutService } from '../../shared/services/layout.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
})

export class UserProfileComponent {
    @ViewChild("ViewUserProfileSection") _viewUserProfileSection: ElementRef;
    @ViewChild("EditUserProfileSection") _editUserProfileSection: ElementRef;

    isLoading = false;
    LoggedInUser?: UserModel;

    editUserProfileClass = "fa-solid fa-pen-to-square";
    UserPasswordClass = "fa-solid fa-lock"

    HiddenPassword = true;
    HiddenOldPassword = true;
    HiddenRetypePassword = true;


    UserProfileDataForm: FormGroup = this._fb.group({}); //A. Register FormGroup
    UserNewPasswordRequestForm: FormGroup = this._fb.group({}); //A. Register FormGroup

    private unsubscribe: Subject<void> = new Subject();

    constructor(
        @Inject('AlertServices') private _alertServices: AlertServices,
        @Inject('UserServices') private _userServices: UserServices,
        private layoutService: LayoutService,
        private _fb: FormBuilder,
        private _router: Router,
        private renderer: Renderer2,
    ) {
        this.UserProfileDataForm = this.initDataForm() //B. Initialize Empty FormGroup Data
        this.UserNewPasswordRequestForm = this.initPasswordDataForm() //B. Initialize Empty FormGroup Data
        this.UserNewPasswordRequestForm.disable()

    }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    ngOnInit() {
        this.LoggedInUser = this._userServices.getLoggedInUser()
        this.LoadUserProfile()
    }



    initDataForm(_instance?) {
        let NewfbGroup = this._fb.group({
            ProjectID: [_instance?.ProjectID],
            Project: [_instance?.Project],
            Hostname: [_instance?.Hostname],

            InstanceID: [_instance?.InstanceID],
            Instance: [_instance?.Instance],
            InstanceTitle: [_instance?.InstanceTitle],

            UserID: [_instance?.UserID],
            AppSettings: [_instance?.AppSettings],
            Name: [_instance?.Name],
            Email: [_instance?.Email, Validators.compose([ioValidators.isEmail])],
            Username: [_instance?.Username],
            Mobile: [_instance?.Mobile],
            RequireOTP: [_instance?.RequireOTP],
            Status: [_instance?.Status],
            DateCreated: [_instance?.DateCreated],

            UserGroupID: [_instance?.UserGroupID],
            GroupName: [_instance?.GroupName],

            UserRoleID: [_instance?.UserRoleID],
            RoleName: [_instance?.RoleName],

            //Project Extended Information
            ProfileURL: [_instance?.ProfileURL],
            apiURL: [_instance?.apiURL],
            hasExtendedInfo: [_instance?.hasExtendedInfo],



        });
        return NewfbGroup;
    }

    LoadExtendedInformation() {
        this._router.navigate([this.UserProfileDataForm.get('ProfileURL').value + this.UserProfileDataForm.get('UserID').value]);
        this.layoutService.toggleNotificationSidebar(false);
    }

    EditUserProfile() {
        if (this.editUserProfileClass === "fa-solid fa-pen-to-square") {
            this.renderer.addClass(this._viewUserProfileSection.nativeElement, "d-none");
            this.renderer.removeClass(this._editUserProfileSection.nativeElement, "d-none");
            this.editUserProfileClass = "fa-solid fa-rectangle-xmark";

        } else {
            this.renderer.addClass(this._editUserProfileSection.nativeElement, "d-none");
            this.renderer.removeClass(this._viewUserProfileSection.nativeElement, "d-none");
            this.editUserProfileClass = "fa-solid fa-pen-to-square";

            this.LoadUserProfile()


            if (this.UserPasswordClass = "fa-solid fa-lock-open") {
                this.RequestNewPassword(); //Reset Password Form if used
            }

        }

    }


    LoadUserProfile() {
        this.UserProfileDataForm = this.initDataForm(this.LoggedInUser);

        if (this.LoggedInUser?.ProfileURL && this.LoggedInUser?.apiURL) {
            this._userServices.GetUserProfileExtendedInfo(this.LoggedInUser).pipe(takeUntil(this.unsubscribe)).subscribe((_response) => {
                this.UserProfileDataForm.get('hasExtendedInfo').setValue(true)
            }, (_error) => {
                //console.log(_error)
            });
        }

    }



    SaveProfileChanges() {

        if (this.UserProfileDataForm.valid) {
            //console.log(this.UserProfileDataForm)

            let UserProfileChanges = new UserProfileModel(this.UserProfileDataForm.getRawValue());
            //console.log(UserProfileChanges)
            this._userServices.UpdateMe(UserProfileChanges).pipe(takeUntil(this.unsubscribe)).subscribe((_response) => {
                //console.log('Updated user information')
            }, (_error) => {
                //console.log(_error)
            });
        }

  
        if (this.UserNewPasswordRequestForm.valid) {

            let UserPasswordInstance = new GuestModel(this.UserNewPasswordRequestForm.getRawValue());
            this._userServices.setPasswordMe(UserPasswordInstance).subscribe((_response) => {
                this.LockNewPasswordSection();
                this._alertServices.ShowToastMessage('success', 'app.trn-success-title', 'app.trn-success-message', true)
            }, (_error) => {
                const _ErrorResponse = JSON.parse(_error._body);
                this._alertServices.ShowToastMessage('error', 'app.trn-error-title', _ErrorResponse.ErrorMessage);
            });


        }

    }



    //PASSWORD SECTION

    RequestNewPassword() {
        if (this.UserPasswordClass === "fa-solid fa-lock") {
            this.UserPasswordClass = "fa-solid fa-lock-open";
            this.UserNewPasswordRequestForm.enable()
            this.UserNewPasswordRequestForm.get('UserID').setValue(this.LoggedInUser.UserID)
        } else {
            this.LockNewPasswordSection();
        }
    }


    LockNewPasswordSection() {
        this.UserPasswordClass = "fa-solid fa-lock";
        this.UserNewPasswordRequestForm = this.initPasswordDataForm() //Reset Form
        this.UserNewPasswordRequestForm.disable()
    }

    initPasswordDataForm(_instance?) {
        let NewfbGroup = this._fb.group({
            UserID: ['', Validators.compose([Validators.required])],
            OldPassword: ['', Validators.compose([Validators.required])],
            Password: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(50), ioValidators.isWeakPassword])],
            PasswordRetype: ['', Validators.compose([Validators.required])]
        }, { validators: ioValidators.PasswordMatcher });
        return NewfbGroup;
    }


}
